
export const urlApi = 'https://paynet.osviel.com:9443';
